module.exports = __webpack_public_path__ + "img/Revista_diseno.6dbbc22a.png";